import { Component, computed, inject, OnInit, signal } from '@angular/core';
import { Location } from '@angular/common';
import { Router } from '@angular/router';
import { Producto } from 'src/app/models/Producto';
import { UsuarioService } from 'src/app/services/usuario.service';
import { firstValueFrom } from 'rxjs';
import { LoadingService } from 'src/app/services/loading.service';
import { AuthService } from 'src/app/services/auth.service';
import { API_URI } from 'src/environments/environment';

@Component({
    selector: 'app-my-account-productos',
    templateUrl: './my-account-productos.component.html',
    styleUrls: ['./my-account-productos.component.css'],
    standalone: false
})
export class MyAccountProductosComponent implements OnInit{
  private _router = inject(Router);
  private _location = inject(Location);

  private _usuarioService = inject(UsuarioService);
  private _authService = inject(AuthService);
  private _loadingService = inject(LoadingService);

  productos = signal<Producto[]>([]);
  error = signal<string>('');
  message = signal<string>('');

  loading = computed(() => this._loadingService.isLoading());
  API_URI = API_URI;

  async ngOnInit(): Promise<void> {
    document.documentElement.scrollTop = 0;

    await this._loadingService.run(async () => {
      try {
        await this._authService.ensureSession();
      } catch (e: any) {
        console.error(e);
        this.error.set(e?.message || 'No se pudo cargar tu cuenta.');
        this._router.navigate(['/sign-in']);
        return;
      }

      await this.cargarProductos();
    });
  }

  private async cargarProductos(): Promise<void> {
    this.error.set('');
    try {
      const res = await firstValueFrom(
        this._usuarioService.getProductos(this._usuarioService.usuario().id!)
      );
      this.productos.set(res ?? []);
    } catch (e: any) {
      console.error(e);
      this.error.set('Error al obtener los productos.');
    }
  }

  async activarDesactivar(producto: Producto, checked: boolean): Promise<void> {
    this.error.set('');
    this.message.set('');

    // optimista: actualizo UI al toque
    const prev = producto.b_activo;
    producto.b_activo = checked;
    this.productos.set([...this.productos()]);

    await this._loadingService.run(async () => {
      try {
        await firstValueFrom(this._usuarioService.updateProducto(producto));
        this.message.set('Modificación realizada correctamente');
        setTimeout(() => this.message.set(''), 2500);
      } catch (e) {
        console.error(e);
        // rollback si falla
        producto.b_activo = prev;
        this.productos.set([...this.productos()]);
        this.error.set('Error al realizar la modificación');
      }
    });
  }

  back() {
    this._location.back();
  }

  trackById = (_: number, item: Producto) => item.id;
}
